import { Col, Modal, Row, Input, Divider } from 'antd';
import * as React from 'react';

import Form, { FormItem } from '../../../components/Form';
import { Title } from '../../../components/Layout/components';

interface ICurrencyDetailProps {
  domain: string;
  currency: GQL.ICurrency;
  currencyList: Array<GQL.ICurrency>;
  languages: Array<GQL.ILanguage>;
  onSave: (currency: GQL.ICurrency) => void;
  onCancel: () => void;
}

interface IDeliveryMethodDetailState {
  currency: GQL.ICurrency;
  currentLanguage: string;
}

export default class CurrencyDetail extends React.Component<ICurrencyDetailProps, IDeliveryMethodDetailState> {

  public constructor(props: ICurrencyDetailProps) {
    super(props);

    this.state = {
      currency: props.currency || {},
      currentLanguage: props.languages.map(l => l.value)[0],
    };

    this.onChange = this.onChange.bind(this);
    this.save = this.save.bind(this);
  }

  public render() {
    const { languages, currencyList } = this.props;
    const { currency, currentLanguage } = this.state;

    const primaryCurrency = currencyList.find((c: GQL.ICurrency) => c.primary === true)

    const title = currencyList.length === 0 ? 'Primary currency' : 'Currency';

    return (
      <div>
        <Title
          languages={languages}
          currentLanguage={currentLanguage}
          onChange={(l: string) => { this.setState({ currentLanguage: l }); }}
        >
          {currency
            ? `${title} ${currency.value ? `"${currency.value}"` : ''}`
            : `${title}`}
        </Title>

        <Divider />
        <Form
          onSubmit={this.save}
          onCancel={this.props.onCancel}
        >
          <FormItem label="Code" required={true}>
            <Input
              autoFocus={true}
              name={'value'}
              placeholder="Currency code (by ISO 4217)"
              value={currency.value}
              required={true}
              onChange={this.onChange}
            />
          </FormItem>

          {primaryCurrency && primaryCurrency.id !== this.state.currency.id &&
            <FormItem label={`Exchange rate to ${primaryCurrency && primaryCurrency.value ? primaryCurrency.value : '?'}`} required={true}>
              <Input
                name={'exchangeRate'}
                placeholder="Currency rate to primary currency"
                value={currency.exchangeRate ? currency.exchangeRate.toString() : ''}
                required={true}
                onChange={this.onChange}
              />
            </FormItem>}

        </Form>
      </div>
    );
  }

  private onChange(e: any, language?: string) {
    const { name, value, checked } = e.target;

    const inputValue = (value !== undefined ? value : checked);
    const newValue = (language
      ? { [name]: { ...this.state.currency[name], [language]: inputValue } }
      : { [name]: value });
    this.setState({
      currency: { ...this.state.currency, ...newValue }
    });
  }

  private async save() {
    const currency = { ...this.state.currency };
    if (this.props.currencyList.length === 0) {
      currency.exchangeRate = 1;
      currency.primary = true;
    }
    this.props.onSave(currency);
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Currencies/CurrencyDetail/CurrencyDetail.tsx